import { ITheme } from "./theme.type";

export const darkTheme: ITheme = {
  name: "dark",
  palette: {
    // Schemes
    primary: {
      main: "#8b81fc",
      opacity: {
        "08": "rgba(176, 198, 255, 0.08)",
        "12": "rgba(176, 198, 255, 0.12)",
        "16": "rgba(176, 198, 255, 0.16)",
      },
    },
    "surface-tint": {
      main: "rgba(209, 225, 255, 1.00)",
      opacity: {
        "08": "rgba(176, 198, 255, 0.08)",
        "12": "rgba(176, 198, 255, 0.12)",
        "16": "rgba(176, 198, 255, 0.16)",
      },
    },
    "on-primary": {
      main: "rgba(6, 46, 111, 1.00)",
      opacity: {
        "08": "rgba(21, 46, 96, 0.08)",
        "12": "rgba(21, 46, 96, 0.12)",
        "16": "rgba(21, 46, 96, 0.16)",
      },
    },
    "primary-container": {
      main: "rgba(8, 66, 160, 1.00)",
      opacity: {
        "08": "rgba(46, 69, 120, 0.08)",
        "12": "rgba(46, 69, 120, 0.12)",
        "16": "rgba(46, 69, 120, 0.16)",
      },
    },
    "on-primary-container": {
      main: "rgba(211, 227, 253, 1.00)",
      opacity: {
        "08": "rgba(217, 226, 255, 0.08)",
        "12": "rgba(217, 226, 255, 0.12)",
        "16": "rgba(217, 226, 255, 0.16)",
      },
    },
    secondary: {
      main: "rgba(127, 207, 255, 1.00)",
      opacity: {
        "08": "rgba(192, 198, 220, 0.08)",
        "12": "rgba(192, 198, 220, 0.12)",
        "16": "rgba(192, 198, 220, 0.16)",
      },
    },
    "on-secondary": {
      main: "rgba(0, 51, 85, 1.00)",
      opacity: {
        "08": "rgba(41, 48, 66, 0.08)",
        "12": "rgba(41, 48, 66, 0.12)",
        "16": "rgba(41, 48, 66, 0.16)",
      },
    },
    "secondary-container": {
      main: "rgba(0, 74, 119, 1.00)",
      opacity: {
        "08": "rgba(64, 70, 89, 0.08)",
        "12": "rgba(64, 70, 89, 0.12)",
        "16": "rgba(64, 70, 89, 0.16)",
      },
    },
    "on-secondary-container": {
      main: "rgba(194, 231, 255, 1.00)",
      opacity: {
        "08": "rgba(220, 226, 249, 0.08)",
        "12": "rgba(220, 226, 249, 0.12)",
        "16": "rgba(220, 226, 249, 0.16)",
      },
    },
    Error: {
      main: "rgba(242, 184, 181, 1.00)",
      opacity: {
        "08": "rgba(242, 184, 181, 0.08)",
        "12": "rgba(242, 184, 181, 0.12)",
        "16": "rgba(242, 184, 181, 0.16)",
      },
    },
    "on-error": {
      main: "rgba(96, 20, 16, 1.00)",
      opacity: {
        "08": "rgba(96, 20, 16, 0.08)",
        "12": "rgba(96, 20, 16, 0.12)",
        "16": "rgba(96, 20, 16, 0.16)",
      },
    },
    "Error-container": {
      main: "rgba(140, 29, 24, 1.00)",
      opacity: {
        "08": "rgba(140, 29, 24, 0.08)",
        "12": "rgba(140, 29, 24, 0.12)",
        "16": "rgba(140, 29, 24, 0.16)",
      },
    },
    "on-error-container": {
      main: "rgba(140, 29, 24, 1.00)",
      opacity: {
        "08": "rgba(249, 222, 220, 0.08)",
        "12": "rgba(249, 222, 220, 0.12)",
        "16": "rgba(249, 222, 220, 0.16)",
      },
    },
    background: {
      main: "rgba(31, 31, 31, 1.00)",
      opacity: {
        "08": "rgba(20, 18, 24, 0.08)",
        "12": "rgba(20, 18, 24, 0.12)",
        "16": "rgba(20, 18, 24, 0.16)",
      },
    },
    "on-background": {
      main: "rgba(227, 227, 227, 1.00)",
      opacity: {
        "08": "rgba(230, 224, 233, 0.08)",
        "12": "rgba(230, 224, 233, 0.12)",
        "16": "rgba(230, 224, 233, 0.16)",
      },
    },
    surface: {
      main: "rgba(31, 31, 31, 1.00)",
      opacity: {
        "08": "rgba(18, 19, 24, 0.08)",
        "12": "rgba(18, 19, 24, 0.12)",
        "16": "rgba(18, 19, 24, 0.16)",
      },
    },
    "on-surface": {
      main: "rgba(227, 227, 227, 1.00)",
      opacity: {
        "08": "rgba(226, 226, 233, 0.08)",
        "12": "rgba(226, 226, 233, 0.12)",
        "16": "rgba(226, 226, 233, 0.16)",
      },
    },
    "surface-variant": {
      main: "rgba(68, 71, 70, 1.00)",
      opacity: {
        "08": "rgba(51, 52, 58, 0.08)",
        "12": "rgba(51, 52, 58, 0.12)",
        "16": "rgba(51, 52, 58, 0.16)",
      },
    },
    "on-surface-variant": {
      main: "rgba(196, 199, 197, 1.00)",
      opacity: {
        "08": "rgba(197, 198, 208, 0.08)",
        "12": "rgba(197, 198, 208, 0.12)",
        "16": "rgba(197, 198, 208, 0.16)",
      },
    },
    outline: {
      main: "rgba(143, 144, 154, 1.00)",
      opacity: {
        "08": "rgba(143, 144, 154, 0.08)",
        "12": "rgba(143, 144, 154, 0.12)",
        "16": "rgba(143, 144, 154, 0.16)",
      },
    },
    "outline-variant": {
      main: "rgba(68, 71, 70, 1.00)",
      opacity: {
        "08": "rgba(68, 70, 79, 0.08)",
        "12": "rgba(68, 70, 79, 0.12)",
        "16": "rgba(68, 70, 79, 0.16)",
      },
    },
    shadow: {
      main: "rgba(0, 0, 0, 1.00)",
      opacity: {
        "08": "rgba(0, 0, 0, 0.08)",
        "12": "rgba(0, 0, 0, 0.12)",
        "16": "rgba(0, 0, 0, 0.16)",
      },
    },
    scrim: {
      main: "rgba(0, 0, 0, 1.00)",
      opacity: {
        "08": "rgba(0, 0, 0, 0.08)",
        "12": "rgba(0, 0, 0, 0.12)",
        "16": "rgba(0, 0, 0, 0.16)",
      },
    },
    "Inverse-on-surface": {
      main: "rgba(227, 227, 227, 1.00)",
      opacity: {
        "08": "rgba(226, 226, 233, 0.08)",
        "12": "rgba(226, 226, 233, 0.12)",
        "16": "rgba(226, 226, 233, 0.16)",
      },
    },
    "inverse-on-surface": {
      main: "rgba(48, 48, 48, 1.00)",
      opacity: {
        "08": "rgba(51, 52, 58, 0.08)",
        "12": "rgba(51, 52, 58, 0.12)",
        "16": "rgba(51, 52, 58, 0.16)",
      },
    },
    "Inverse-primary": {
      main: "#4c43ac",
      opacity: {
        "08": "rgba(72, 94, 146, 0.08)",
        "12": "rgba(72, 94, 146, 0.12)",
        "16": "rgba(72, 94, 146, 0.16)",
      },
    },
    "primary-fixed": {
      main: "#8b81fc",
      opacity: {
        "08": "rgba(173, 195, 254, 0.08)",
        "12": "rgba(173, 195, 254, 0.12)",
        "16": "rgba(173, 195, 254, 0.16)",
      },
    },
    "on-primary-fixed": {
      main: "rgba(4, 30, 73, 1.00)",
      opacity: {
        "08": "rgba(0, 25, 70, 0.08)",
        "12": "rgba(0, 25, 70, 0.12)",
        "16": "rgba(0, 25, 70, 0.16)",
      },
    },
    "primary-fixed-dim": {
      main: "#8b81fc",
      opacity: {
        "08": "rgba(146, 168, 225, 0.08)",
        "12": "rgba(146, 168, 225, 0.12)",
        "16": "rgba(146, 168, 225, 0.16)",
      },
    },
    "on-primary-fixed-variant": {
      main: "rgba(8, 66, 160, 1.00)",
      opacity: {
        "08": "rgba(50, 69, 116, 0.08)",
        "12": "rgba(50, 69, 116, 0.12)",
        "16": "rgba(50, 69, 116, 0.16)",
      },
    },
    "secondary-fixed": {
      main: "rgba(194, 231, 255, 1.00)",
      opacity: {
        "08": "rgba(217, 223, 246, 0.08)",
        "12": "rgba(217, 223, 246, 0.12)",
        "16": "rgba(217, 223, 246, 0.16)",
      },
    },
    "on-secondary-fixed": {
      main: "rgba(0, 29, 53, 1.00)",
      opacity: {
        "08": "rgba(21, 27, 44, 0.08)",
        "12": "rgba(21, 27, 44, 0.12)",
        "16": "rgba(21, 27, 44, 0.16)",
      },
    },
    "secondary-fixed-dim": {
      main: "rgba(127, 207, 255, 1.00)",
      opacity: {
        "08": "rgba(192, 198, 220, 0.08)",
        "12": "rgba(192, 198, 220, 0.12)",
        "16": "rgba(192, 198, 220, 0.16)",
      },
    },
    "on-secondary-fixed-variant": {
      main: "rgba(0, 74, 119, 1.00)",
      opacity: {
        "08": "rgba(64, 70, 89, 0.08)",
        "12": "rgba(64, 70, 89, 0.12)",
        "16": "rgba(64, 70, 89, 0.16)",
      },
    },
    "surface-dim": {
      main: "rgba(19, 19, 19, 1.00)",
      opacity: {
        "08": "rgba(18, 19, 24, 0.08)",
        "12": "rgba(18, 19, 24, 0.12)",
        "16": "rgba(18, 19, 24, 0.16)",
      },
    },
    "surface-Bright": {
      main: "rgba(55, 57, 59, 1.00)",
      opacity: {
        "08": "rgba(56, 57, 63, 0.08)",
        "12": "rgba(56, 57, 63, 0.12)",
        "16": "rgba(56, 57, 63, 0.16)",
      },
    },
    "surface-container-lowest": {
      main: "rgba(14, 14, 14, 1.00)",
      opacity: {
        "08": "rgba(12, 14, 19, 0.08)",
        "12": "rgba(12, 14, 19, 0.12)",
        "16": "rgba(12, 14, 19, 0.16)",
      },
    },
    "surface-container-low": {
      main: "rgba(27, 27, 27, 1.00)",
      opacity: {
        "08": "rgba(26, 27, 33, 0.08)",
        "12": "rgba(26, 27, 33, 0.12)",
        "16": "rgba(26, 27, 33, 0.16)",
      },
    },
    "surface-container": {
      main: "rgba(30, 31, 32, 1.00)",
      opacity: {
        "08": "rgba(30, 31, 37, 0.08)",
        "12": "rgba(30, 31, 37, 0.12)",
        "16": "rgba(30, 31, 37, 0.16)",
      },
    },
    "surface-container-high": {
      main: "rgba(40, 42, 44, 1.00)",
      opacity: {
        "08": "rgba(40, 42, 47, 0.08)",
        "12": "rgba(40, 42, 47, 0.12)",
        "16": "rgba(40, 42, 47, 0.16)",
      },
    },
    "surface-container-highest": {
      main: "rgba(51, 53, 55, 1.00)",
      opacity: {
        "08": "rgba(51, 52, 58, 0.08)",
        "12": "rgba(51, 52, 58, 0.12)",
        "16": "rgba(51, 52, 58, 0.16)",
      },
    },
    "success-container": {
      main: "rgba(209, 250, 229, 1.00)",
      opacity: {
        "08": "rgba(209, 250, 229, 0.08)",
        "12": "rgba(209, 250, 229, 0.12)",
        "16": "rgba(209, 250, 229, 0.16)",
      },
    },
    "on-success-container": {
      main: "rgba(6, 78, 59, 1.00)",
      opacity: {
        "08": "rgba(6, 78, 59, 0.08)",
        "12": "rgba(6, 78, 59, 0.12)",
        "16": "rgba(6, 78, 59, 0.16)",
      },
    },
  },
};